export default "__VITE_ASSET__z6Hd23Y$__"